import { render, staticRenderFns } from "./EmailGatewayStatus.vue?vue&type=template&id=442a0f91&scoped=true&"
import script from "./EmailGatewayStatus.vue?vue&type=script&lang=js&"
export * from "./EmailGatewayStatus.vue?vue&type=script&lang=js&"
import style0 from "./EmailGatewayStatus.vue?vue&type=style&index=0&id=442a0f91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a0f91",
  null
  
)

export default component.exports